import React from 'react'
import { observer } from "mobx-react";
import { useStores } from "../../stores/rootStore";
import { ModalWrapper } from 'src/components/ModalWrapper';
import { Notifier } from 'src/components/Notifier';
import { QARFormQuarters } from './quarters';
import { QARFormManagers } from './managers';
import { QARFormTable } from './table';
import { QARFormFooter } from './footer';

export const QARFormWrapper = observer(() => {

  const { qarFormStore } = useStores();

  const renderComponents = () => {
    if (qarFormStore.quarters?.length === 0) {
      return (
        <>
          <p>You do not have any generated Quarterly Access Review Forms currently or previously.</p>
        </>
      );
    }

    return (
      <>
        <QARFormQuarters></QARFormQuarters>
        <QARFormManagers></QARFormManagers>
        <QARFormTable></QARFormTable>
        <QARFormFooter></QARFormFooter>
      </>
    );
  }

  return (
    <div id="qar-form-wrapper">
      {renderComponents()}
      <ModalWrapper></ModalWrapper>
      <Notifier></Notifier>
    </div>
  )

});